"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Primitives = require("../primitives/Primitives");

var _FooterInfoStyles = require("../styles/FooterInfo/FooterInfoStyles");

var _AppText = _interopRequireDefault(require("./AppText"));

var _utils = require("../utils");

var _this = void 0,
    _jsxFileName = "/home/vsts/work/1/s/common/build/web/temp/components/FooterInfo.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var FooterInfo = function FooterInfo(props) {
  return _react["default"].createElement(_Primitives.Box, {
    style: _objectSpread(_objectSpread({}, _FooterInfoStyles.Styles.footer), props.containerStyle),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, _react["default"].createElement(_Primitives.Box, {
    style: _FooterInfoStyles.Styles.footerInfoSection,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, _react["default"].createElement(_AppText["default"], {
    iconName: "exclamation-circle",
    iconColor: _utils.Colors.WHITE_LIGHT,
    iconSize: _utils.Constants.IS_WEB ? 'xl' : 'xxl',
    containerStyle: {
      flexDirection: 'row',
      flexShrink: 1
    },
    textStyle: {
      color: _utils.Colors.WHITE_LIGHT,
      textAlign: 'center',
      flex: 1,
      flexWrap: 'wrap'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }, "This tool is not intended for patients who need hemodialysis catheter access or for pediatric vascular access procedure selection."), _react["default"].createElement(_AppText["default"], {
    textStyle: _FooterInfoStyles.Styles.footerText2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }, "\xA9 2021 Kidney CARE Network International. All Right Reserved.")));
};

var _default = FooterInfo;
exports["default"] = _default;